<template>
  <v-layout row wrap>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-card-title>Add Extra Page</v-card-title>
          <v-container>
            <v-form @submit.prevent="postExtraPage()">
              <v-text-field
                label="Page Title"
                v-model="page.name"
                :rules="requiredRules"
                required
              ></v-text-field>
              <label>Description</label>
              <vue-editor v-model="page.description"></vue-editor>
              <button class="btn btn-block pantone" @click="postExtraPage()">Publish</button>
            </v-form>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
    <v-flex lg6 md6 sm12 xs12>
      <v-container>
        <v-card flat>
          <v-container>
            <h2>{{page.name}}</h2>
            <br>
            <span v-html="page.description"></span>
          </v-container>
        </v-card>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  name: 'add-page',
  components: {
    VueEditor
  },
  data () {
    return {
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      page: {
        name: '',
        page_type: 'normal',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_page', 'normal')
  },
  methods: {
    postExtraPage: function () {
      this.$store.dispatch('post_page', this.page)
    }
  }
}
</script>

<style scoped>

</style>
